// Lets logout clear the @seekjobs/events-ui module token without importing the
// package into the main bundle. The package registers its clearModuleToken when
// the Events chunk loads; if it never loaded, there is no token to clear.
let clearToken = null;

export const registerEventsModuleLogout = fn => {
  clearToken = typeof fn === 'function' ? fn : null;
};

export const clearEventsModuleToken = () => {
  if (clearToken) clearToken();
};
